import withReactContent from 'sweetalert2-react-content';
import { QueryClient, MutationCache } from 'react-query';
import Swal from 'sweetalert2';

import i18n from '../app/i18n';
import store from '../lib/redux/store';
import { setNotification } from '../lib/redux/notification/notificationSlice';

const ReactSwal = withReactContent(Swal);

const redirectUser = (dispatch, mutation) => {
  dispatch(
    setNotification({
      variant: 'error',
      content: i18n.t('accountSettings:passwordForm.unauthorized'),
      disappear: true,
    }),
  );

  setTimeout(() => {
    document.location = document.location.origin;
  }, 3000);

  mutation.reset();
};

const showError = (dispatch, error) => {
  const { data } = error.response;

  if (Object.keys(data).length === 0) return;

  // TO-DO return ONE consistent error key name on backend
  const errorKey = Object.keys(data).find(key => key !== 'notification');

  const errorMessage = data[errorKey];

  const content =
    errorMessage && Object.keys(errorMessage).length !== 0
      ? [errorMessage].flat().join('')
      : i18n.t('shared:errorText');

  dispatch(
    setNotification({
      variant: 'error',
      content,
      disappear: true,
    }),
  );
};

const mutationCache = new MutationCache({
  onError: (error, variables, context, mutation) => {
    const { dispatch } = store;

    ReactSwal.close();

    if (error.response.status === 401) {
      redirectUser(dispatch, mutation);
      return;
    }

    if (error.response.data.notification) {
      showError(dispatch, error);
    }
  },
});

const queryClient = new QueryClient({
  mutationCache,
  queries: {
    refetchInterval: false,
  },
});

export default queryClient;
